import { Injectable, inject } from '@angular/core';
import { DOPGroup } from '../../model/crm/daily-operating-plan/dop-group';
import { AorBuilderService } from './aor-builder.service';
import { DOPLabel } from '../../model/crm/daily-operating-plan/dop-label';
import { getCorrectedDate } from '../../utils/utils';
import { DOPEntry } from '../../model/crm/daily-operating-plan/dop-entry';
import { DOPAcknowledgement } from '../../model/crm/daily-operating-plan/dop-acknowledegment';

@Injectable({
  providedIn: 'root',
})
export class DopBuilderService {
  private _aorBuilder = inject(AorBuilderService);

  buildDOPGroup(item: any): DOPGroup {
    return {
      id: item.id,
      name: item.name,
      enabled: item.enabled,
      deletedAt: getCorrectedDate(item.deletedAt)!,
      aors: item.AORs.map((aor: any) => this._aorBuilder.buildAor(aor)),
    };
  }

  buildDOPLabel(item: any): DOPLabel {
    return {
      id: item.id,
      labelText: item.labelText,
      active: item.active,
      createdBy: item.createdBy,
      createdAt: getCorrectedDate(item.createdAt)!,
      updater: item.updater,
      updatedAt: getCorrectedDate(item.updatedAt)!,
      deletedAt: getCorrectedDate(item.deletedAt)!,
    };
  }

  buildDOPEntry(item: any): DOPEntry {
    return {
      id: item.id,
      aorId: item.aorId,
      aorSubSystemId: item.aorSubSystemId,
      labelId: item.labelId,
      entry: item.entry,
      shiftDate: item.shiftDate,
      active: item.active,
      createdBy: item.createdBy,
      createdAt: getCorrectedDate(item.createdAt)!,
      updater: item.updater,
      updatedAt: getCorrectedDate(item.updatedAt)!,
      deletedAt: getCorrectedDate(item.deletedAt)!,
      version: item.version,
      aor: item.AOR ? this._aorBuilder.buildAor(item.AOR) : null,
      aorSubSystem: item.AORSubSystem
        ? this._aorBuilder.buildAORSubsystem(item.AORSubSystem)
        : null,
      dopLabel: item.DOPLabel ? this.buildDOPLabel(item.DOPLabel) : null,
      time: item.updatedAt
        ? getCorrectedDate(item.updatedAt)!
        : getCorrectedDate(item.createdAt)!,
      user: item.updater ? item.updater : item.createdBy,
      note: item.entry,
    };
  }

  buildDOPAcknowledgement(item: any): DOPAcknowledgement {
    return {
      id: item.id,
      dopGroupId: item.dopGroupId,
      contactId: item.contactId,
      shiftDate: item.shiftDate,
      createdAt: getCorrectedDate(item.createdAt)!,
      dopState: item.dopState,
    };
  }
}
